export default "__VITE_ASSET__$sjBQ5t2__"